<template>
  <div class="padlet-browser side-panel side-panel-with-curtain" @click.self="close">
    <div class="panel-container is-animated slide-from-right">
      <header class="panel-header panel-header-with-content">
        <div class="panel-left-item">
          <button class="text-button narrow-button" @click="close" v-t>Close</button>
        </div>
        <div class="panel-title" v-t>Padlets</div>
        <div class="panel-right-item" />
      </header>
      <base-text-tabs
        class="padlet-browser-tabs panel-header-content-last"
        :tabs="[
          { text: __('Recents'), key: 'recents' },
          { text: __('Made'), key: 'made' },
          { text: __('Shared'), key: 'shared' },
          { text: __('Liked'), key: 'liked' },
          { text: __('Network'), key: 'network' },
        ]"
        :active-key="activeFilter"
        :click-handler="changeFilter"
        size="small"
      />
      <div v-if="walls.length > 0" class="padlet-browser-results">
        <padlet-list :walls="walls" :sort-by="activeSort" :navigate="false" @select="select" />
      </div>
      <div v-else :class="{ 'padlet-browser-messages': true, 'padlet-browser-empty-message': loading === 0 }">
        <loading-spinner v-if="loading > 0" />
        <div v-else-if="errored" class="caption-type" v-t>Oops! Something went wrong. Please try again.</div>
        <div v-else class="caption-type" v-t>No padlets in this folder.</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import PadletList from 'vuecomponents/padlet_list'
import LoadingSpinner from 'vuecomponents/loading_spinner'
import localStorage from 'bits/safe_storage'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { USER_PADLETS } from 'graphql/padlets'
import IntlMixin from 'vuemixins/intl_mixin'
import BaseTextTabs from 'vuecomponents/base_text_tabs.vue'
import { captureMessage } from 'bits/error_tracker'

export default {
  components: { PadletList, LoadingSpinner, BaseTextTabs },
  mixins: [EscapeToCancelMixin, IntlMixin],
  props: ['user'],
  data() {
    let activeFilter = localStorage.getItem('activePadletFilter') || 'recents'
    // there may still be "folder_xxx" values in localStorage at first after we split filter and folder
    // We can remove the block below after a while
    if (/^folder_/.test(activeFilter) || activeFilter === 'archived') {
      activeFilter = 'recents'
    }
    return {
      walls: [],
      activeFilter: activeFilter,
      activeSort: localStorage.getItem('activePadletSort') || 'date',
      loading: 0,
      errored: false,
    }
  },
  apollo: {
    walls: {
      query: USER_PADLETS,
      variables: function() {
        return {
          userId: this.user.id,
          wallsFilter: this.activeFilter,
          shouldFetchLinks: true,
        }
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      watchLoading(isLoading) {
        if (isLoading) {
          this.errored = false
        }
      },
      error(error) {
        this.errored = true
        captureMessage('GraphQL Error in padlet browser', {
          context: {
            message: error.message,
          },
        })
      },
      update(data) {
        if (this.errored) {
          return []
        }
        return data.user.walls.edges.map(e => e.node) || []
      },
    },
  },
  methods: {
    cancel() {
      this.close()
    },
    close() {
      this.$emit('close')
    },
    select(wall) {
      this.$emit('select', wall.links.permanent)
    },
    changeFilter(newFilter) {
      this.activeFilter = newFilter
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.padlet-browser-results {
  margin-top: 24px;
  overflow: auto;
  flex-grow: 1;
}
.padlet-browser-messages {
  flex-grow: 1;
  padding: 32px;
  font-size: $big-body-font-size;
  line-height: $big-body-line-height;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.padlet-browser-empty-message {
  background-image: url(../images/cactus_mobile.png);
  background-size: contain;
  background-position: bottom right;
  background-repeat: no-repeat;
}
.padlet-browser-tabs {
  height: 36px;
  background: white;
}
</style>
